export default "/fonts/Poppins-Medium.ttf?4e2dc0d293b53de4df92424cf0563d14";